var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadonly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#063a32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "ic_fluent_read_only_24_filled"), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD0D-System-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_read_only_24_filled",
    fill: "#063a32",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.21968,2.21967 C2.48594364,1.95340636 2.90261223,1.92920884 3.19622222,2.14706241 L3.28034,2.21968 L21.7801,20.7198 C22.073,21.0127 22.073,21.4876 21.7801,21.7805 C21.5138273,22.0467727 21.0971413,22.0709793 20.8035207,21.8531198 L20.7194,21.7805 L14,15.0609 L9.0621,19.9987 C8.83136667,20.22945 8.55379306,20.4066583 8.24906088,20.5189245 L8.06312,20.5784 L2.94743,21.9736 C2.42049353,22.1173176 1.93442848,21.6707294 2.00636631,21.1509001 L2.02652,21.0527 L3.42171,15.937 C3.50756833,15.62225 3.66064194,15.330625 3.86951301,15.0819745 L4.00144,14.9381 L8.9392,10.0000075 L2.21966,3.28033 C1.92677,2.98743 1.92678,2.51256 2.21968,2.21967 Z M13.9393,4.99963 L19.0003,10.0606 L16.1207,12.9402 L11.0599,7.87922 L13.9393,4.99963 Z M21.0304,2.96973 C22.4279,4.36719 22.4279,6.63293 21.0304,8.03039 L20.0603,8.99963 L14.9993,3.93963 L15.9698,2.96973 C17.3672,1.57227 19.633,1.57227 21.0304,2.96973 Z",
    id: "\\uD83C\\uDFA8-Color"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadonly);
export default __webpack_public_path__ + "static/media/readonly.ba120474a82fc8a18a07a5cf4b6b5187.svg";
export { ForwardRef as ReactComponent };